export function asyncWait(timeToWait?: number) {
	return new Promise((resolve) => {
		setTimeout(resolve, timeToWait)
	})
}
